import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content bg-primary-white" }
const _hoisted_2 = { class: "container p-2 p-md-2" }
const _hoisted_3 = { class: "modal-header d-flex justify-content-between py-3" }
const _hoisted_4 = { class: "title-4 text-grey-900 text-capitalize" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "position-fixed fixed-bottom py-2 px-4 w-100 container"
}

import { computed, ref, watch } from 'vue'
  import { useStore } from '@/store'

  // UI components
  import CloseButton from '@/components/UI/Button.vue'
  import ArrowLeft from '@/assets/ArrowLeftIcon.vue'
  import Button from '@/components/UI/Button.vue'
  import { ComputedRef } from 'vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  type SlideDirection = 'from-left' | 'from-right'

  interface Props {
    isPanelVisible: boolean
    slideDirection: SlideDirection
    onClose?: () => void
    onConfirm?: () => void
    closeTitle?: string
    displayConfirmButton?: boolean
    buttonDisabled?: boolean
    isLoading?: boolean
    hasOverlay?: boolean
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SlidingPanel',
  props: {
    isPanelVisible: { type: Boolean, default: false },
    slideDirection: { default: 'from-right' },
    onClose: {},
    onConfirm: {},
    closeTitle: {},
    displayConfirmButton: { type: Boolean },
    buttonDisabled: { type: Boolean },
    isLoading: { type: Boolean },
    hasOverlay: { type: Boolean }
  },
  setup(__props: any) {

  const { t } = useI18n()

  // Props
  const props = __props

  // Refs
  const isOpen = ref(false)

  // Handle panel close
  const store = useStore()

  const handleClose = () => {
    props.onClose && props.onClose()
  }

  const handleConfirm = () => {
    props.onConfirm && props.onConfirm()
  }

  // Computed properties
  const transitionName = computed(() => {
    const name =
      props.slideDirection === 'from-left' ? 'slide-left' : 'slide-right'
    return name
  })

  const overlayPanelClasses = computed(() => {
    return {
      'w-30 position-right':
        props.hasOverlay && props.slideDirection === 'from-right',
      'w-30 position-left':
        props.hasOverlay && props.slideDirection === 'from-left',
    }
  })

  const panelClasses = computed(() => ({
    'position-right': props.slideDirection === 'from-right',
    'position-left': props.slideDirection === 'from-left',
    ...overlayPanelClasses.value,
  }))

  const openSet: ComputedRef<Set<string>> = computed(() => {
    return store.getters['modal/openSet']
  })

  // Watcher to sync panel visibility
  watch(
    () => props.isPanelVisible,
    newValue => {
      isOpen.value = newValue
      if (openSet.value.size) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'visible'
      }
    },
    { immediate: true }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#sliding-panel-container" }, [
    (_ctx.hasOverlay && isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay position-fixed top-0 start-0 end-0 bottom-0 bg-black-50 bg-primary-black opacity-25",
          onClick: handleClose
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: transitionName.value,
      appear: ""
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["modal-dialog-slide modal-page position-fixed top-0 bottom-0", _ctx.hasOverlay && overlayPanelClasses.value])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-dialog-slide modal-page position-fixed top-0 bottom-0", panelClasses.value])
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(CloseButton, {
                        classes: ['btn', 'p-0', 'd-flex', 'align-items-center'],
                        onClick: handleClose
                      }, {
                        svg: _withCtx(() => [
                          _createVNode(ArrowLeft)
                        ]),
                        text: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.closeTitle), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(CloseButton, {
                        classes: ['ts-x-black', 'bg-grey-200'],
                        onClick: handleClose
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "default"),
                      (_ctx.displayConfirmButton)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(Button, {
                              class: "w-100",
                              onButtonClick: handleConfirm,
                              disabled: _ctx.buttonDisabled,
                              loading: _ctx.isLoading
                            }, {
                              text: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('panels.confirm')), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _renderSlot(_ctx.$slots, "bottom")
                ])
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["name"])
  ]))
}
}

})